import { render, staticRenderFns } from "./HeaderPanel.vue?vue&type=template&id=5b2480c9&scoped=true"
import script from "./HeaderPanel.vue?vue&type=script&lang=js"
export * from "./HeaderPanel.vue?vue&type=script&lang=js"
import style0 from "./HeaderPanel.vue?vue&type=style&index=0&id=5b2480c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2480c9",
  null
  
)

export default component.exports